import { useSelector } from 'react-redux'
import styled from 'astroturf/react'
import { Link } from '@calendly/ui/components/link'
import { MinimalButton } from '@calendly/ui/components/minimal-button'
import { BodyText } from '@calendly/ui/components/typography'
const colorTextSecondary = 'var(--colorTextSecondary, var(--coreColorNeutral600))'

import { BrandLogo } from 'components/layout/brand_logo'
import { useI18n } from 'locales'
import { isEmbeddedSelector } from 'selectors/embed'
import _GridRow from "booking_redesign_legal_footer-GridRow.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/layout/booking_redesign_legal_footer.js?styleId=GridRow";
import _LogoWrap from "booking_redesign_legal_footer-LogoWrap.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/layout/booking_redesign_legal_footer.js?styleId=LogoWrap";
import _RightLinks from "booking_redesign_legal_footer-RightLinks.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/layout/booking_redesign_legal_footer.js?styleId=RightLinks";
import _CookieButton from "booking_redesign_legal_footer-CookieButton.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/layout/booking_redesign_legal_footer.js?styleId=CookieButton";


const checkIfIframe = () => window.location !== window.parent.location

const GridRow = /*#__PURE__*/styled('div', null, {
  displayName: "GridRow",
  styles: _GridRow
})

const LogoWrap = /*#__PURE__*/styled('div', null, {
  displayName: "LogoWrap",
  styles: _LogoWrap
})

const RightLinks = /*#__PURE__*/styled('div', null, {
  displayName: "RightLinks",
  styles: _RightLinks
})

const CookieButton = /*#__PURE__*/styled(MinimalButton, null, {
  displayName: "CookieButton",
  styles: _CookieButton
})

export const BookingRedesignLegalFooter = ({ className }) => {
  const { i18n } = useI18n()
  const embedFromStore = useSelector(isEmbeddedSelector)
  const isEmbedded = checkIfIframe() || embedFromStore

  return (
    <GridRow className={className}>
      <LogoWrap>
        <BrandLogo size="20px" />
      </LogoWrap>
      <RightLinks>
        <CookieButton onClick={() => window.OneTrust?.ToggleInfoDisplay()}>
          <BodyText as="span" inline size="medium" color={colorTextSecondary}>
            {i18n.t('booking.terms_and_conditions.manage_cookies')}
          </BodyText>
        </CookieButton>
        {!isEmbedded && (
          <Link
            underline={false}
            href="https://calendly.com/legal/privacy-notice"
            target="_blank"
            rel="noopener noreferrer"
          >
            <BodyText as="span" inline size="medium" color={colorTextSecondary}>
              {i18n.t('booking.terms_and_conditions.privacy_policy')}
            </BodyText>
          </Link>
        )}
      </RightLinks>
    </GridRow>
  )
}
